import { Tag, TagLabel, TagProps } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { ProfessionFragment } from '../../graphql/generated/definitions';

import { Link } from "../wombat-ui";

type ProfessionTagProps = TagProps & {
  profession: ProfessionFragment;
  disabled?: boolean;
};

const ProfessionTag: React.FC<ProfessionTagProps> = ({
  profession,
  disabled = false,
  children,
  ...props
}) => {
  const havingAnswersMatching = useMemo(
    () =>
      JSON.stringify(
        profession.skills.map(({ id }) => ({
          skillId: id
        }))
      ),
    [profession.skills]
  );

  return (
    <Tag id={`profession_badge_${profession.id}`} {...props}>
      <TagLabel
        as={Link}
        color="currentcolor"
        to={`/users?havingAnswersMatching=${encodeURIComponent(
          havingAnswersMatching
        )}`}
        data-test-id={`badge_profession_badge_${profession.id}`}
        disabled={disabled}
      >
        {profession.name}
      </TagLabel>
      {children}
    </Tag>
  );
};

export default ProfessionTag;
